import styled from 'styled-components';

export const WelcomeWrap = styled.div`
  display: flex;
  flex: 12;
  justify-content: center;
`;
